// frontend/src/components/UserAccount.js
import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem, Typography, Avatar, Divider, Switch } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import UserProfile from './UserProfile';
// *** KORRIGIERTER IMPORT ***
import { useUserPreferences } from '../context/UserPreferencesContext';

function UserAccount({ userPayload, onLogout }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  // *** Nutze den Context-Hook ***
  const { preferredView, savePreferences, isSavingPreferences } = useUserPreferences();

  const open = Boolean(anchorEl);

  // Benutzerinfos direkt aus userPayload holen
  const userName = userPayload?.name || ''; // Sicherstellen, dass userPayload existiert
  const userEmail = userPayload?.email || ''; // Sicherstellen, dass userPayload existiert

  const handleClick = (event) => { setAnchorEl(event.currentTarget); };
  const handleClose = () => { setAnchorEl(null); };
  const handleProfileOpen = () => { setOpenProfile(true); handleClose(); };
  const handleProfileClose = () => { setOpenProfile(false); };

  // Handler für den Switch
  const handleViewChange = async (event) => {
    const newView = event.target.checked ? 'card' : 'table';
    // Speichere nur die geänderte Präferenz
    await savePreferences({ preferredView: newView });
    // Optional: Feedback geben (Snackbar könnte hier nützlich sein)
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        size="large"
        sx={{ ml: 2 }} // Behalte Margin bei, falls gewünscht
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        {/* Avatar-Styling wie in deiner vorherigen Version */}
        <Avatar sx={{ width: 40, height: 40, bgcolor: 'primary.main' }}>
          <AccountCircle sx={{ width: 30, height: 30, color: 'white' }} />
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        // onClick={handleClose} // Entfernt, damit Switch funktioniert
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {/* Zeige Infos nur an, wenn sie vorhanden sind */}
        {userName && <MenuItem disabled><Typography variant="body1" sx={{ fontWeight: 'bold' }}>{userName}</Typography></MenuItem>}
        {userEmail && <MenuItem disabled><Typography variant="body2" color="text.secondary">{userEmail}</Typography></MenuItem>}
        {(userName || userEmail) && <Divider sx={{ my: 0.5 }} />}
        <MenuItem onClick={handleProfileOpen}>Profil & Einstellungen</MenuItem>

        {/* Neuer Menüpunkt für den Switch */}
        <MenuItem
            // Verhindert Schließen des Menüs beim Klicken auf den Switch selbst
            onClick={(e) => e.stopPropagation()}
            // Deaktivieren während des Speicherns
            disabled={isSavingPreferences}
            sx={{ justifyContent: 'space-between', cursor: 'default' }} // Layout und Cursor
            // Entferne Hover-Effekt, da es kein direkter Klick-Handler ist
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
        >
            <Typography variant="body2">Kartenansicht</Typography>
            <Switch
                checked={preferredView === 'card'}
                onChange={handleViewChange}
                // Verhindert, dass Klick auf Switch das Menü schließt
                onClick={(e) => e.stopPropagation()}
                size="small"
            />
        </MenuItem>
        {/* Ende neuer Menüpunkt */}

        <MenuItem onClick={onLogout}>Logout</MenuItem>
      </Menu>
      {/* UserProfile braucht onColumnsSaved nicht mehr direkt */}
      <UserProfile open={openProfile} onClose={handleProfileClose} />
    </Box>
  );
}

export default UserAccount;
